import React, { useState, useEffect } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import { getApiInstance } from "../../../utils/api";
import { useZone } from "../../../context/ZoneContext";
import { useTranslation } from "react-i18next";
import { FaUserEdit } from "react-icons/fa";
import Badge from "../../../components/common/Badge/Badge";
import { MdVisibility as MdVisibilityIcon } from "react-icons/md";
import { mapList } from "../../../utils/utils";

export default function Usuarios({ user }) {
    const { t } = useTranslation();
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();
    const [intermediarios, setIntermediarios] = useState([]);

    const columnasUsuarios = [
        { key: "id", label: "codUsuario", visible: false },
        { key: "codUsuario", label: "codUsuario", visible: false },
        {
            key: "nombre",
            label: t("fields.user"),
            visible: true,
            sortable: true,
            render: (row) => {
                return (
                    <div className="table-cell-content">
                        <span className="table-cell-content__primary table-cell-content__primary--bold">
                            {`${row.nombre} ${row.apellidos}`}
                        </span>
                        <span className="table-cell-content__secondary">
                            {row.email}
                        </span>
                    </div>
                );
            },
        },
        {
            key: "perfil",
            label: t("fields.profile"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        {
            key: "acceso",
            label: t("fields.access"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
            render: (row) => {
                const variant =
                    row.acceso === "Gestión" ? "primary" : "neutral";
                const Icon =
                    row.acceso === "Gestión" ? FaUserEdit : MdVisibilityIcon;
                return (
                    <Badge variant={variant} Icon={Icon}>
                        {row.acceso}
                    </Badge>
                );
            },
        },
        {
            key: "intermediario",
            label: t("fields.intermediaryCompany"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        {
            key: "telefono",
            label: t("fields.phone"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
    ];

    const filterFields = [
        { key: "perfil", label: t("fields.profile"), type: "multiselect" },
        { key: "acceso", label: t("fields.access"), type: "multiselect" },
        {
            key: "intermediario",
            label: t("fields.intermediaryCompany"),
            type: "multiselect",
        },
    ];

    useEffect(() => {
        fetchUsuarios();
        fetchIntermediarios();
    }, [selectedZone]);

    const fetchUsuarios = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let usuariosData = [];

            const response = await api.get(
                `/api/Usuario/GetUsuariosByZona/${selectedZone.value}`
            );
            usuariosData = response.data;

            console.log("Paises data fetched:", usuariosData);

            setUsuarios(usuariosData);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los usuarios. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchIntermediarios = async () => {
        const api = getApiInstance();
        try {
            let intermediariosData = [];

            const response = await api.get(
                `/api/Intermediarios/GetIntermediariosByZona/${selectedZone.value}`
            );
            intermediariosData = response.data;

            setIntermediarios([
                ...mapList(intermediariosData, "nombre", "codIntermediario"),
            ]);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los intermediarios. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const ALL_PROFILE_OPTIONS = [
        { label: t("fields.profileAdministratorZone"), value: 2 },
        { label: t("fields.profileCenterManager"), value: 3 },
        { label: t("fields.profileIntermediary"), value: 4 },
    ];

    const formElements = [
        {
            elements: [
                {
                    name: "nombre",
                    type: "text",
                    label: t("fields.name"),
                    placeholder: t("placeholders.enterName"),
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "apellidos",
                    type: "text",
                    label: t("fields.lastName"),
                    placeholder: t("placeholders.enterLastName"),
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "email",
                    type: "email",
                    label: t("fields.email"),
                    placeholder: t("placeholders.enterEmail"),
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "telefono",
                    type: "tel",
                    label: t("fields.phone"),
                    placeholder: t("placeholders.enterPhone"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                // {
                //     name: "codPerfil",
                //     type: "select",
                //     label: t("fields.profile"),
                //     placeholder: t("placeholders.selectProfile"),
                //     required: true,
                //     disabled: false,
                //     labelVisible: true,
                //     visible: true,
                //     options: ALL_PROFILE_OPTIONS,
                // },
                // {
                //     name: "codAcceso",
                //     type: "select",
                //     label: t("fields.access"),
                //     placeholder: t("placeholders.selectAccess"),
                //     required: true,
                //     disabled: false,
                //     labelVisible: true,
                //     visible: true,
                //     options: [
                //         { label: t("fields.accessManagemenet"), value: 1 },
                //         { label: t("fields.accessConsulting"), value: 2 },
                //     ],
                // },
                {
                    name: "codIntermediario",
                    type: "select",
                    label: t("fields.intermediaryCompany"),
                    placeholder: t("productionCenters.form.selectIntermediary"),
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: intermediarios,
                },
                {
                    name: "codZona",
                    type: "number",
                    label: "Zona",
                    visible: false,
                    defaultValue: selectedZone.value,
                },
            ],
        },
    ];

    return (
        <PageLayout title={t("users.title")} subtitle={t("users.subtitle")}>
            <Table
                columns={columnasUsuarios}
                dataTable={usuarios}
                showCheckboxes={true}
                expandable={true}
                expandableBreakpoint={600}
                noResultsMessage={t("users.noResultsFound")}
                actions={[t("common.delete"), t("common.edit")]}
                searchTerms={[
                    t("fields.name"),
                    t("fields.lastName"),
                    t("fields.email"),
                    t("fields.phone"),
                ]}
                elementName={t("fields.users")}
                keyProp="codUsuario"
                sortProp="nombre"
                loading={loading}
                filterFields={filterFields}
                formElements={formElements}
                addApiUrl="/api/Usuario/SetUsuario"
                editApiUrl="/api/Usuario/EditUsuario"
                deleteApiUrl="/api/Usuario/DeleteUsuario"
                userCodAcceso={Number(user.codAcceso)}
                userCodPerfil={Number(user.role)}
            />
        </PageLayout>
    );
}
